import { render, staticRenderFns } from "./otherFile.vue?vue&type=template&id=647c59f4&scoped=true"
import script from "./otherFile.vue?vue&type=script&lang=js"
export * from "./otherFile.vue?vue&type=script&lang=js"
import style0 from "./otherFile.vue?vue&type=style&index=0&id=647c59f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647c59f4",
  null
  
)

export default component.exports